
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

export const searchProcedimientosByTerm = async (
  search = '', 
  establecimiento = ''
) => {

  

  const query = `
    query MyQuery($search: String, $establecimiento: String) {
      allProcs(search: $search, establecimiento: $establecimiento) {
        status
        total
        totalSns
        procedimiento {
          id
          codigo
          descripcion
        }
        procedimientosSns {
          id
          codigo
          descripcion
        }
      }
    }
  `;
  const variables = { search, establecimiento }

  try {
    const response = await axios.post(rutas.axios + "api", { query, variables } );
    const allProcs = response.data?.data?.allProcs || {};
    const procedimientos = allProcs.procedimiento || [];
    const procedimientosSns = (allProcs.procedimientosSns || []).map((item) => ({
      ...item,
      id: `sns-${item.id}`,
      descripcion: `${item.descripcion} [SNS]`,
      source: "sns",
    }));
    return [...procedimientos, ...procedimientosSns];

  } catch (error) {
    console.error("Error fetching procedimientos:", error);
  }
}


const searchProcedimientosByTermSelect = async (search, establecimiento) => {

  const response = await searchProcedimientosByTerm(search, establecimiento);

  const data = (response || []).map(item => ({
    value: item.id,
    text: `${item.codigo} ${item.descripcion}`
  }));

  return data;
}


export const procedimientosService = {
  searchProcedimientosByTerm,
  searchProcedimientosByTermSelect
}
